import { makeStyles } from 'tss-react/mui';
import { theme } from '../theme';

/**
 * Custom hook that defines the styles for the header component.
 * @returns An object containing the class names for the header component.
 */
const useHeaderStyles = makeStyles()(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${theme.padding.m}`,
    height: '60px',
    maxWidth: '100%',
    minWidth: '700px',
    backgroundColor: theme.background.darker,
  },
  title: {
    'position': 'absolute',
    'marginLeft': 'auto',
    'marginRight': 'auto',
    'left': 0,
    'right': 0,
    '@media (max-width: 700px)': {
      position: 'relative',
    },
    'fontFamily': theme.fontFamily,
    'fontSize': theme.fontSize.h1,
    'fontWeight': theme.fontWeight.bold,
    'color': 'white',
    'textAlign': 'center',
    'textShadow':
      '-0.75px -0.75px 0 #FFA500, 0.75px -0.75px 0 #FFA500, -0.75px 0.75px 0 #FFA500, 0.75px 0.75px 0 #FFA500',
    'zIndex': 0,
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    zIndex: 1,
  },
  logo: {
    'height': '80%',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menuAndSearchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '25%',
    minWidth: '250px',
    zIndex: 1,
  },
  menu: {
    'marginLeft': '20px',
    'color': 'white',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  searchBar: {
    maxWidth: '300px',
  },
}));

export default useHeaderStyles;
